import Button from "elements/Button";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updatePassword } from "store/actions/profileAction";

import { passwordPattern } from "utils/formPattertn";
import { handleConfirmSwal } from "utils/sweetAlert";

function ModalChangePass() {
  const [data, setData] = useState({
    oldPassword: "",
    password: "",
  });

  const dispatch = useDispatch();

  const [passShow, setPassShow] = useState(false);
  const [passValid, setPassValid] = useState(null);

  const onChange = (event) => {
    const { name, value } = event.target;
    if (passwordPattern.test(data.password)) {
      setPassValid(true);
    } else {
      setPassValid(false);
    }

    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (data.oldPassword !== "" && data.password !== "") {
      handleConfirmSwal(
        "Are you sure?",
        "Your password will be updated",
        "warning",
        true,
        "Yes, update it!"
      ).then((result) => {
        if (result.isConfirmed) {
          dispatch(updatePassword(data));
          setData({
            oldPassword: "",
            password: "",
          });
        }
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div
        className="modal fade"
        id="modalPassword"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Change Password
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              {/* OLD PASS */}
              <div className="form-group mb-3">
                <label htmlFor="oldPassword">Old Password</label>
                <div className="input-group">
                  <input
                    type={passShow ? "text" : "password"}
                    name="oldPassword"
                    id="oldPassword"
                    value={data.oldPassword}
                    onChange={onChange}
                    className="form-control"
                    placeholder="Please type here..."
                    aria-label="oldPassword"
                    required
                  />
                  <span className="input-group-text" id="basic-addon1">
                    <i
                      onClick={() => setPassShow(!passShow)}
                      className={`fas ${passShow ? "fa-eye" : "fa-eye-slash"}`}
                    ></i>
                  </span>
                </div>
              </div>

              {/* NEW PASS */}
              <div className="form-group mb-3">
                <label htmlFor="password">New Password</label>
                <div className="input-group">
                  <input
                    type={passShow ? "text" : "password"}
                    name="password"
                    id="password"
                    value={data.password}
                    onChange={onChange}
                    className={`form-control ${
                      passValid === false ? "is-invalid" : ""
                    }`}
                    placeholder="Please type here..."
                    aria-label="Password"
                    required
                  />
                  <span className="input-group-text" id="basic-addon1">
                    <i
                      onClick={() => setPassShow(!passShow)}
                      className={`fas ${passShow ? "fa-eye" : "fa-eye-slash"}`}
                    ></i>
                  </span>
                </div>
                {!passValid && (
                  <div className="validation mt-1">
                    *password must be at least 8 character 1 uppercase and 1
                    number
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <Button type="button" className="btn btn-primary">
                Save changes
              </Button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default ModalChangePass;
